import React, {Component} from 'react'
import Header from './Header'
import Table from './Table'

class Additional extends Component {
  render() {
    return(
      <div className='card'>
        <Header/>
        <Table/>
      </div>
    )
  }
}

export default Additional
